/**
 * Gets the first 10 characters from text for use as chat title
 * @param {string} text - The text to process
 * @returns {string} - First 10 characters or 'Untitled Chat'
 */
export const getFirstTenChars = (text) => {
  if (!text || !text.trim()) return 'Untitled Chat';
  return text.trim().substring(0, 10) || 'Untitled Chat';
};

